import React from "react";
import Utils from "../../js/utils";
import SimpleGraph from "./SimpleGraph.jsx";

const isTrip = window.location.hostname === 'trip.cocopacket.com';

class GraphCompare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detail: null, // null | 'exit' | 'probe'
        }
    }

    parseProbeExit = (probe) => {
        if(typeof probe === 'string') {
            const probeName = probe.split('slave=')[1];
            if(typeof probeName === 'string') {
                if(probeName.toLowerCase().startsWith('cache')) {
                    return null
                }
                const probeNameSplit = probeName.split('-');
                if (probeNameSplit.length > 1) {
                    const exit = probeNameSplit[probeNameSplit.length-1];

                    return {name: probeNameSplit.slice(0, -1).join('-') , exit};
                }
            }
        }
        return null;
    }

    getProbeGraphs = (list) => {
        return list.map(probe => {
            const newProbe = `slave=${probe}`;

            return newProbe !== this.props.ipDetails.probe && (
                <div className={'graphCompare'} key={probe}>
                    <div className={'titleWrap'}>
                        <span className={'title'}>{probe}</span>
                    </div>
                    <SimpleGraph
                        ref={`graph-${probe}`}
                        {...this.props}
                        hideGraphInfo={true}
                        ipDetails={{
                            ...this.props.ipDetails,
                            probe: newProbe
                        }}
                    />
                </div>
            );
        })
    }

    getProbes = (probeName, probeExit, probeList) => {
        const probes = probeList.filter(probe => probe !== `${probeName}-${probeExit}`)
        const sameExit = probes.filter(probe => probe.includes(probeExit));
        const samePop = probes.filter(probe => probe.startsWith(probeName));

        if(sameExit.length === 0 && samePop === 0) {
            return null;
        }

        return {pop: samePop, exit: sameExit};
    }

    setView = (view) => {
        this.setState(prevState => ({
            detail: prevState.detail === view ? null : view
        }))
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.detail !== this.state.detail){
            this.props.setShowCompare(this.state.detail !== null);
        }
    }

    render() {
        const probe = Utils.getPropertyOfObject(['ipDetails', 'probe'], this.props, null);
        const probesList = Utils.getPropertyOfObject(['probesList'], this.props, null);
        const probeInfo = this.parseProbeExit(probe);
        if (probeInfo === null || probesList === null || !isTrip) {
            return null;
        }

        const probes = this.getProbes(probeInfo.name, probeInfo.exit, probesList);

        if (probes === null) {
            return null;
        }

        const showProbes = this.state.detail !== null;
        const filteredProbes = this.state.detail === 'exit'
                ? probes.exit
                : probes.pop;

        return (
            <div className={'graphCompareWrap'}>
                <div className={'head'}>
                    <span className={'title'}>
                        Graph Compare
                    </span>
                    <div className={'controls'}>
                        {probes.exit.length > 0 && (
                            <button
                                type={'button'}
                                className={'button'}
                                onClick={() => {this.setView('exit')}}>
                                {this.state.detail === 'exit'
                                    ? `Hide ${probeInfo.exit}`
                                    : `Show ${probeInfo.exit} (${probes.exit.length})`
                                }
                            </button>
                        )}
                        {probes.pop.length > 0 && (
                            <button
                                type={'button'}
                                className={'button'}
                                onClick={() => {this.setView('probe')}}>
                                {this.state.detail === 'probe'
                                    ? `Hide ${probeInfo.name}`
                                    : `Show ${probeInfo.name} (${probes.pop.length})`
                                }
                            </button>
                        )}
                    </div>
                </div>
                {showProbes && (<div className={'divCol'}>
                    {this.getProbeGraphs(filteredProbes)}
                </div>)}
            </div>
        );
    }
}

export default GraphCompare;
